import { memo, useRef } from "react";
import { Editor } from "@tinymce/tinymce-react";
import { Editor as TinyMCEEditor } from "tinymce";
import axios from "axios";
import { CreateNotification } from "../notifier";

interface Prop {
  value?: string;
  onChangedValue?: (a: string, editor: TinyMCEEditor) => void;
  onKeyDown?: (e: any) => void;
}

const TINYMCE_API_KEY = "l9ml76yoeorz19bgr4fkqicxo080tvfk7onestimqcs7kevt";
const VIAG_API_BASE_URL = "https://viagsapi.azurewebsites.net/api";
const BORDER_DEFAULT_WIDTH = 1.778;
const MARGIN_DEFAULT_WIDTH = 8;

const viagsUploadFile = (formData: FormData) => axios.post(`${VIAG_API_BASE_URL}/uploadfile/upload-file-img`, formData);

export const TinyEditor = memo((props: Prop) => {
  const { value, onChangedValue, onKeyDown = () => {} } = props;
  const editorRef = useRef<TinyMCEEditor | null>(null);

  const onInitEditor = (evt: any, editor: any) => {
    editorRef.current = editor;
    const element = document.getElementById("editor-content");
    element?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <Editor
      apiKey={TINYMCE_API_KEY}
      onKeyDown={(e) => onKeyDown(e)}
      onEditorChange={onChangedValue}
      onInit={onInitEditor}
      initialValue={value}
      init={{
        language_url: `${process.env.PUBLIC_URL}/languages/vi.js`,
        language: "vi",
        height: "12cm",
        width: `calc(21cm + ${BORDER_DEFAULT_WIDTH * 2}px + ${MARGIN_DEFAULT_WIDTH * 3 + 1}px)`,
        menubar: true,
        plugins: [
          "advlist",
          "autolink",
          "lists",
          "link",
          "image ",
          "charmap",
          "preview",
          "anchor",
          "searchreplace",
          "visualblocks",
          "code",
          "fullscreen",
          "insertdatetime",
          "media",
          "table",
          "code",
          "help",
          "wordcount",
          "lineheight",
        ],
        content_css: "/index.css",
        textpattern_patterns: [
          { start: "*", end: "*", format: "italic" },
          { start: "**", end: "**", format: "bold" },
          { start: "~", end: "~", cmd: "createLink", value: "https://tiny.cloud" },
          { start: "1. ", cmd: "InsertOrderedList" },
          { start: "* ", cmd: "InsertUnorderedList" },
          { start: "- ", cmd: "InsertUnorderedList" },
        ],
        toolbar:
          "undo redo | fontfamily |fontsize | blocks " +
          "bold italic forecolor | alignleft aligncenter " +
          "alignright alignjustify lineheight | bullist numlist outdent indent | " +
          "removeformat | help",
        content_style:
          ".editor-parent-fullscreen { display: flex; justify-content: center; background-color: #e5e6ea; } .mce-content-body { font-size:14px;font-family:'times new roman',sans-serif; width: 21cm; background-color: #fff;} .editor-fullscreen { border: 1px solid #c7c7c6; width: calc(21cm); margin: 8px 0px; padding: 8px; } p { line-height: 1.5; margin: 0px; color: #000; }",
        font_family_formats: "times new roman",
        automatic_uploads: true,
        image_uploadtab: true,
        images_upload_credentials: true,
        file_picker_types: "image",
        convert_urls: false,
        line_height_formats: "1 1.15 1.5 2 2.5 3",
        file_picker_callback: function (cb) {
          var input: any = document.createElement("input");
          input.setAttribute("type", "file");
          input.setAttribute("accept", "image/*");
          input.onchange = async function () {
            var file = input.files[0];
            var formData = new FormData();
            formData.append("file", file);
            try {
              CreateNotification({ title: "Thông báo", body: "Đang tải lên tệp tin...", icon: "/icons/info.png" });
              const response = await viagsUploadFile(formData);
              if (response.data.statusCode === 200) {
                cb(response?.data?.data, { title: file.name });
              } else {
                CreateNotification({
                  title: "Thông báo",
                  body: "Định dạng này không hợp lệ, vui lòng chọn các định dạng khác (.jpg, .jpeg, .gif)",
                  icon: "/icons/error.png",
                });
              }
            } catch (error) {
              console.error(error);
            }
          };
          input.click();
        },
        setup: (editor) => {
          editor.on("FullscreenStateChanged", function (e) {
            const editorBody = editor.getBody();
            if (editorBody) {
              if (e.state) {
                editorBody.classList.add("editor-fullscreen");
              } else {
                editorBody.classList.remove("editor-fullscreen");
              }

              const parentElement = editorBody.parentElement;
              if (parentElement) {
                if (e.state) {
                  parentElement.classList.add("editor-parent-fullscreen");
                } else {
                  parentElement.classList.remove("editor-parent-fullscreen");
                }
              }
            }
          });
        },
      }}
    />
  );
});
